import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaGraduationCap, FaUserMd, FaMicroscope, FaCertificate, FaUsers, FaArrowRight, FaClock, FaBook } from 'react-icons/fa';
import './ourcourses.css';
import { Button } from 'react-bootstrap';



function Ourcourses() {
  const [hoveredCard, setHoveredCard] = useState(null);

const courses = [
{
  id: 1,
  title: "Ophthalmic Optician (NVQ Level 03)",
  description: "Focused training in ophthalmic dispensing, including spectacle and lens selection, measurements, adjustments, and patient guidance.",
  duration: "06 Months",
  level: "Certificate",
  icon: FaCertificate,
  image: "certificate in optician.jpg",
  link: "/ophthalmicoptician",
  color: "#44b7f9ff",
  features: [
    "Spectacle & Lens Dispensing",
    "Measurements and Adjustments",
    "Patient Care"
  ]
},


    {
      id: 2,
      title: "Certificate in Ophthalmic Assistant",
      description: "Gain comprehensive expertise in opticianry with extensive hands-on clinical experience and theoretical knowledge.",
      duration: "01 year",
      level: "Certificate",
      icon: FaCertificate,
      image: "ophthalmic assistant.png",
      link: "/certificateinoptician",
      color: "#0e11b6ff",
      features: ["Practical Training", "Industry Exposure", "Certification"]
    },
    {
      id: 3,
      title: "Diploma in Optometry (NVQ Level 04)",
      description: "Master optometry principles and vision science through advanced clinical practice and research methodologies.",
      duration: "02 Years",
      level: "Diploma",
      icon: FaGraduationCap,
      image: "diploma img1.jpg",
      link: "/diplomainoptometry",
      color: "#066b49ff",
      features: ["Clinical Practice", "Research Methods", "Advanced Optics"]
    },
    {
      id: 4,
      title: "Higher Diploma in Optometry (NVQ Level 06)",
      description: "Advanced professional training in optometric sciences with specialized clinical rotations and research projects.",
      duration: "2 Years & 06 Months",
      level: "Higher Diploma",
      icon: FaUserMd,
      image: "higher diploma.jpeg",
      link: "/higherdiplomainoptometry",
      color: "#fea100ff",
      features: ["Specialized Training", "Clinical Rotations", "Research Projects"]
    },
    {
      id: 5,
      title: "Fellowship Courses",
      description: "Specialized advanced courses focusing on cutting-edge optometric techniques and clinical applications.",
      duration: "06 Months",
      level: "Fellowship",
      icon: FaMicroscope,
      image: "fellowship img.jpg",
      link: "/fellowshipcourse",
      color: "#5610f9ff",
      features: ["Advanced Techniques", "Clinical Applications", "Specialization"]
    },
    {
      id: 6,
      title: "Fellowship Workshops",
      description: "Intensive skill development workshops focusing on advanced optometric management and clinical procedures.",
      duration: "1-5 Days",
      level: "Workshop",
      icon: FaUsers,
      image: "Workshopimg.jpg",
      link: "/onedayworkshop",
      color: "#f13535ff",
      features: ["Skill Enhancement", "Latest Technologies", "Hands-on Training"]
    },
            {
          id: 7,
          title: "NVQ Course | Level 3 & 5",
          description: "Comprehensive NVQ Level 3 Ophthalmic optician training designed to develop practical competencies, industry knowledge, and professional skills required for excellence in optician level practice.",
          duration: "",
          level: "NVQ Level 3 & 5",
          icon: FaCertificate,
          image: "NVQ-certificates.jpg",
          link: "/registration-course",
          color: "#d39b00ff",
          features: ["Skill Enhancement", "Clinical Applications", "Hands-on Training"]
        }
  ];

  const cardVariants2 = {
    hidden: { opacity: 0, y: 50 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6 }
    },
    hover: {
      y: -15,
      scale: 1.02,
      transition: { duration: 0.3 }
    }
  };


  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6 }
    },
    hover: {
      y: -15,
      scale: 1.02,
      transition: { duration: 0.3 }
    }
  };

  return (
    <section className="courses-section">
      <div className="container">
        <motion.div 
          className="section-header text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Faculty of Optometry</h2>
          <p className="section-subtitle">Choose from our comprehensive range of optometry programs designed for career success</p>
        </motion.div>

        <div className="courses-grid">
          {courses.map((course, index) => (
            <motion.div
              key={course.id}
              className="course-card"
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              whileHover="hover"
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              onMouseEnter={() => setHoveredCard(course.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="card-header">
                <div 
                  className="card-icon"
                  style={{ backgroundColor: `${course.color}15`, borderColor: course.color }}
                >
                  <course.icon style={{ color: course.color }} />
                </div>
                <div className="course-level" style={{ backgroundColor: course.color }}>
                  {course.level}
                </div>
              </div>

              <div className="card-image">
                <img src={course.image} alt={course.title} />
                <div className="image-overlay" style={{ backgroundColor: `${course.color}20` }}></div>
              </div>

              <div className="card-content">
                <h3 className="course-title">{course.title}</h3>
                <p className="course-description">{course.description}</p>
                
                <div className="course-duration">
                  <FaClock />
                  <span>{course.duration}</span>
                </div>

                <div className="course-features">
                  {course.features.map((feature, idx) => (
                    <span key={idx} className="feature-tag" style={{ borderColor: course.color }}>
                      {feature}
                    </span>
                  ))}
                </div>
              </div>

              <div className="card-footer">
                <motion.a 
                  href={course.link}
                  className="learn-more-btn"
                  style={{ 
                    backgroundColor: hoveredCard === course.id ? course.color : 'transparent',
                    borderColor: course.color,
                    color: hoveredCard === course.id ? 'white' : course.color
                  }}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  Learn More
                  <FaArrowRight />
                </motion.a>
              </div>

              {/* Hover Effect Border */}
              <div 
                className="hover-border"
                style={{ 
                  background: `linear-gradient(135deg, ${course.color}, ${course.color}dd)`,
                  opacity: hoveredCard === course.id ? 1 : 0
                }}
              ></div>
            </motion.div>
          ))}
        </div>

        <motion.div 
          className="section-footer text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <p className="info-text">Can't find what you're looking for?</p>
          <motion.a 
            href="/contactus"
            className="contact-link"
            whileHover={{ scale: 1.05 }}
          >
            Contact Our Academic Advisors <FaArrowRight />
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
}

export default Ourcourses;